<style scoped>
.body {
  margin-top: 64px;
}
</style>

<template lang='pug'>
  div
    app-header
    .body
      transition(name='fade', mode='out-in')
        router-view
      app-footer
</template>
<script>
import AppHeader from './app-header.vue'
import AppFooter from './app-footer.vue'

export default {
  meta: {
    title: 'Spirits & Liquor Direct',
    titleTemplate: '%s - Inom PH'
  },
  components: {
    AppHeader,
    AppFooter
  }
}
</script>


// WEBPACK FOOTER //
// src/components/template-alternate.vue